import { cn } from "@/lib/utils";
import { isDeletedUserLabel } from "@/lib/deletedSender";
import UserProfileDialog from "./UserProfileDialog";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  sender: string;
  avatarId?: string;
  senderDeleted?: boolean;
}

export default function MessageSender({
  sender,
  avatarId = "",
  senderDeleted,
  className,
}: Props) {
  // A deleted sender is NOT interactive: the profile dialog's Contact action
  // would create a DM against a non-existent account — and, worse,
  // createDMChat's name lookup can silently open an arbitrary chat already
  // named "Deleted User". Render a plain, non-clickable label instead.
  if (senderDeleted || isDeletedUserLabel(sender)) {
    return (
      <span
        className={cn(
          "truncate text-sm leading-snug tracking-tighter text-foreground/90",
          className,
        )}
      >
        {sender}
      </span>
    );
  }

  return (
    <UserProfileDialog username={sender} avatarId={avatarId}>
      <button
        type="button"
        className={cn(
          "cursor-pointer truncate text-sm leading-snug tracking-tighter text-foreground/90 hover:underline",
          className,
        )}
      >
        {sender}
      </button>
    </UserProfileDialog>
  );
}
